import React, {
  Suspense,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import "./App.scss";
import Home from "./components/home/Home";
import Baas from "./components/Login/Baas";
import Spinner from "./components/Common/Loading/Spinner";
import AuthContext from "./Store/auth-context";
// import { ToastContainer, toast } from "react-toastify";

import LandingPage from "./components/ondc/LandingPage/LandingPage";
import Authentication from "./components/ondc/Authentication/Authentication";
import OndcRegistration from "./components/ondc/Authentication/Registration/OndcRegistration";
import OndcLogin from "./components/ondc/Authentication/Login/OndcLogin";
import { toast, ToastContainer } from "react-toastify";
import { generateRandomNumber, partnerDetails } from "./util/utils";
import PrivateRoute from "./layouts/PrivateRoute";
import { useDispatch, useSelector } from "react-redux";
import { HTTPS } from "./services/HTTPS";
import {
  getPartnerProfileAppUrl,
  loginUrlAppUrl,
} from "./components/Services/Constant";
import axios from "axios";
import { setPreviousPath } from "./Store/reducers/pathNameSlice";

//Screens
const Login = React.lazy(() =>
  import("./components/Login/CredentialsFolder/Login")
);
const Registration = React.lazy(() =>
  import("./components/Registration/Registration")
);
const ResetPass = React.lazy(() =>
  import("./components/Login/CredentialsFolder/ResetPass/ResetPass")
);
const ForgetPassword = React.lazy(() =>
  import("./components/Login/CredentialsFolder/ForgetPassword/ForgetPassword")
);
const Profile = React.lazy(() =>
  import("./components/home/pages/profile/Profile")
);

const Contact = React.lazy(() =>
  import("./components/home/pages/profile/contactUs/ContactUs")
);
const ChangePassword = React.lazy(() =>
  import("./components/home/pages/profile/ChangePassword/ChangePassword")
);
const Otp = React.lazy(() =>
  import("./components/Login/CredentialsFolder/Otp/otp")
);

//Pages
const HomePage = React.lazy(() =>
  import("./components/home/pages/HomePage/HomePage")
);
const Summary = React.lazy(() => import("./components/Common/Summary/Summary"));
const Transaction = React.lazy(() =>
  import("./components/home/pages/payIn/Transaction/Transaction")
);
const Wallet = React.lazy(() =>
  import("./components/home/pages/payOut/Wallet/Wallet")
);
const Beneficiary = React.lazy(() =>
  import("./components/home/pages/payOut/Beneficiaries/Beneficiary")
);
const OutTransaction = React.lazy(() =>
  import("./components/home/pages/payOut/OutTransaction/Transaction")
);
const VendorWallet = React.lazy(() =>
  import("./components/home/pages/vendor/Wallet/wallet")
);
const OrderHistory = React.lazy(() =>
  import("./components/Common/OrderHistory/OrderHistory")
);
const TransferStatus = React.lazy(() =>
  import("./components/home/pages/status/TransferStatus/TransferStatus")
);
const BeneStatus = React.lazy(() =>
  import("./components/home/pages/status/BeneStatus/BeneStatus")
);
const DetailBulk = React.lazy(() =>
  import("./components/Common/DetailBulk/DetailBulk")
);
const BulkUploadDetails = React.lazy(() =>
  import("./components/Common/DetailBulk/BulkUploadDetails")
);
const StepLayout = React.lazy(() => import("./layouts/StepLayout"));

// Dashboard
const Dashboard = React.lazy(() =>
  import("./components/home/pages/ondc/dashboard/Dashboard")
);

//Product
const AddProduct = React.lazy(() =>
  import("./components/home/pages/Product/AddProducts/AddProduct")
);
const ProductList = React.lazy(() =>
  import("./components/home/pages/Product/ProductList/ProductList")
);
const ProductDetails = React.lazy(() =>
  import("./components/home/pages/Product/ProductDetails/ProductDetails")
);

//null-variant-products
const NullVariantProductList = React.lazy(() =>
  import(
    "./components/home/pages/Product/NullVariantProductList/NullVariantProductList"
  )
);

//My variant
const MyVariant = React.lazy(() =>
  import("./components/home/pages/Product/VariantList/VariantList")
);

//My Variant
const MyVariantProduct = React.lazy(() =>
  import("./components/home/pages/Product/MyVariant/MyVariant")
);

//Channels
const Channels = React.lazy(() =>
  import("./components/home/pages/Product/Channels/Channels")
);

const ChannelProductAdd = React.lazy(() =>
  import("./components/home/pages/Product/Channels/ChannelProductAdd")
);

const VariantProductList = React.lazy(() =>
  import("./components/home/pages/Product/VariantList/VariantProductList")
);

const BulkEdit = React.lazy(() =>
  import("./components/home/pages/Product/BulkEdit/BulkEdit")
);

//Order
const OrderList = React.lazy(() =>
  import("./components/home/pages/Order/OrderList/OrderList")
);
const OrderDetails = React.lazy(() =>
  import("./components/home/pages/Order/OrderDetails/OrderDetails")
);
const OrderCancel = React.lazy(() =>
  import("./components/home/pages/Order/OrderCancel/OrderCancel")
);
const ShipmentsList = React.lazy(() =>
  import("./components/home/pages/Order/Shipments/ShipmentsList")
);

//Bulk Invoice
const BulkInvoice = React.lazy(() =>
  import("./components/home/pages/Order/BulkInvoice/BulkInvoiceList")
);

//Offer
const OfferList = React.lazy(() =>
  import("./components/home/pages/Offer/OfferList/OfferList")
);
const OfferDetails = React.lazy(() =>
  import("./components/home/pages/Offer/OfferDetails/OfferDetails")
);
const AddOffer = React.lazy(() =>
  import("./components/home/pages/Offer/AddOffer/AddOffer")
);
const ItemBased = React.lazy(() =>
  import("./components/home/pages/Offer/ItemBased/ItemBased")
);
const Freebie = React.lazy(() =>
  import("./components/home/pages/Offer/Freebie/Freebie")
);

const StoreQrList = React.lazy(() =>
  import("./components/home/pages/StoreQr/StoreQrList")
);

const MyWebsite = React.lazy(() =>
  import("./components/home/pages/MyWebsite/MyWebsite")
);

// this is for the redirection to the newly hosted Website of the seller
const ExternalRedirect = () => {
  //window.location.replace("https://sellertest.wow.in/");
  window.open("https://sellertest.openkart.co.in/", "_self");
  return null;
};

const MyWebsiteAccount = React.lazy(() =>
  import("./components/home/pages/MyWebsite/Account/Account")
);
const MyWebsiteCategoryProducts = React.lazy(() =>
  import("./components/home/pages/MyWebsite/CategoryProducts/CategoryProducts")
);
const MyWebsiteProductDetails = React.lazy(() =>
  import("./components/home/pages/MyWebsite/ProductDetails/ProductDetails")
);
const MyWebsiteCart = React.lazy(() =>
  import("./components/home/pages/MyWebsite/Cart/Cart")
);
const MyWebsiteSubcategoryProducts = React.lazy(() =>
  import("./components/home/pages/MyWebsite/SubcategoryProducts/SubcategoryProducts")
);
const MyWebsiteCheckout = React.lazy(() =>
  import("./components/home/pages/MyWebsite/Checkout/Checkout")
);
const MyWebsitePro = React.lazy(() =>
  import("./components/home/pages/MyWebsite/Pro/Pro")
);
const MyWebsiteOrderHistory = React.lazy(() =>
  import("./components/home/pages/MyWebsite/OrderHistory/OrderHistory")
);

const AddQuotation = React.lazy(() =>
  import("./components/home/pages/Quotation/AddQuotation/AddQuotation")
);
const Categories = React.lazy(() =>
  import("./components/home/pages/Quotation/Categories/Categories")
);
const QuotationCategoryDetail = React.lazy(() =>
  import(
    "./components/home/pages/Quotation/QuotationCategoryDetail/QuotationCategoryDetail"
  )
);
const CustomCategoryBuilder = React.lazy(() =>
  import(
    "./components/home/pages/Quotation/CustomCategory/CustomCategoryBuilder"
  )
);
const QuotationProductForm = React.lazy(() =>
  import(
    "./components/home/pages/Quotation/QuotationProductForm/QuotationProductForm"
  )
);
const ManageProfile = React.lazy(() =>
  import("./components/home/pages/Quotation/ManageProfile/ManageProfile")
);
const QuotationOrders = React.lazy(() =>
  import("./components/home/pages/Quotation/QuotationOrders/QuotationOrders")
);
const QuotationOrderDetail = React.lazy(() =>
  import("./components/home/pages/Quotation/QuotationOrders/QuotationOrderDetail")
);

const QuotationCustomers = React.lazy(() =>
  import("./components/home/pages/Quotation/QuotationCustomers/QuotationCustomers")
);
const QuotationCustomerDetail = React.lazy(() =>
  import("./components/home/pages/Quotation/QuotationCustomers/QuotationCustomerDetail")
);

// Return Order
const ReturnOrderList = React.lazy(() =>
  import("./components/home/pages/Return/ReturnOrderList/ReturnOrderList")
);
const ReturnOrderDetails = React.lazy(() =>
  import("./components/home/pages/Return/ReturnOrderDetails/ReturnOrderDetails")
);
// const ReturnOrderCancel = React.lazy(() => import('./components/home/pages/Order/OrderCancel/OrderCancel'))
//Issue
const IssueList = React.lazy(() =>
  import("./components/home/pages/Issue/IssueList/IssueList")
);
const IssueDetails = React.lazy(() =>
  import("./components/home/pages/Issue/IssueDetails/IssueDetails")
);

// Profile
const SellerProfile = React.lazy(() =>
  import("./components/home/pages/profile/SellerProfile")
);

//Help
const Help = React.lazy(() => import("./components/home/pages/Help/Help"));

//FreqAskQues
const FreqAskQues = React.lazy(() =>
  import("./components/home/pages/FreqAskQues/FreqAskQues")
);

// Customer
const CustomerList = React.lazy(() =>
  import("./components/home/pages/customer/customerList/CustomerList")
);

// Buyer
const BuyerList = React.lazy(() =>
  import("./components/home/pages/Buyer/BuyerList/BuyerList")
);

// LSP
const LogisticPartnerList = React.lazy(() =>
  import(
    "./components/home/pages/LogisticPartners/LogisticPartnerList/LogisticPartnerList"
  )
);

const Payments = React.lazy(() =>
  import("./components/home/pages/payments/Payments")
);

const Adjustments = React.lazy(() =>
  import("./components/home/pages/payments/Adjustments")
);

const Ledger = React.lazy(() =>
  import("./components/home/pages/payments/BankLedger")
);

//MultiStores
const MultiStores = React.lazy(() =>
  import("./components/home/pages/multiStores/MultiStores")
);

//MultiUsers
const MultiUsers = React.lazy(() =>
  import("./components/home/pages/MultiUsers/MultiUsers")
);
const AddMultiUsers = React.lazy(() =>
  import("./components/home/pages/MultiUsers/AddMultiUsers")
);

//Downloads
const Downloads = React.lazy(() =>
  import("./components/home/pages/Report/Downloads")
);

//UpgradePlan
const UpgradePlan = React.lazy(() =>
  import("./components/home/pages/UpgradePlan/UpgradePlan")
);
const PlanList = React.lazy(() =>
  import("./components/home/pages/UpgradePlan/PlanList")
);

//T & C
const TermsAndConditions = React.lazy(() =>
  import("./components/home/pages/Report/TermsAndConditions")
);
// Fees
const Fees = React.lazy(() => import("./components/home/pages/Fees/Fees"));

function setFavicon(imageUrl) {
  const head = document.querySelector("head");
  const favicon = document.createElement("link");
  favicon.rel = "shortcut icon";
  favicon.type = "image/x-icon";
  favicon.href = imageUrl;
  head.appendChild(favicon);
}

function App() {
  const toastId = useRef(null);
  const [locationPath, setLocationPath] = useState("");
  const [loading, setLoading] = useState(false);
  const [loginRequest, setLoginRequest] = useState(true);
  const authCtx = useContext(AuthContext);
  const isLoggedIn = authCtx.isLoggedIn;
  const { pathname } = useLocation();
  const currentPath = useSelector((state) => state.pathname.previousPath);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  // const toastId = React.useRef(null);

  // const logoutHandler = (userName) => {
  //   // const authCtx = useContext(AuthContext);
  //   sessionStorage.clear(userName);
  //   localStorage.removeItem('')
  //   if (localStorage.getItem("theme") === "dark") {
  //     document.body.classList.remove("dark-theme");
  //     localStorage.setItem("theme", "light");
  //   }
  //   authCtx.logOut();
  //   document.title="EasyPay";
  // };

  // function runEveryThreeSeconds() {
  //   const userName = sessionStorage.getItem('userName');
  //   const verifyToken = localStorage.getItem(userName);
  //   if(isLoggedIn) {
  //     if(!verifyToken) {
  //       logoutHandler(userName);
  //       window.location.reload();
  //       // if(! toast.isActive(toastId.current)) {
  //       //   toastId.current = toast.error("some one try to login");
  //       // }
  //     }
  //   }
  // }

  // setInterval(runEveryThreeSeconds, 3000);

  const getUrlDetails = async (e) => {
    setLoading(true);
    // let payload = {
    //   host: window.location.href,
    // };

    try {
      const response = await axios.get("https://api.ipify.org?format=json");
      sessionStorage.setItem("ipAddress", response.data.ip);
      const payload = {
        HEADER: {
          UDID: response.data.ip,
          REQUEST_ID: generateRandomNumber(),
        },
        DATA: {
          host: window.location.href,
        },
      };

      await HTTPS(getPartnerProfileAppUrl, payload)
        .then((formResponse) => {
          setLoading(false);
          if (
            formResponse.RESP_CODE === 300 &&
            Object.keys(formResponse.DATA).length
          ) {
            sessionStorage.setItem(
              "partnerDetails",
              JSON.stringify(formResponse.DATA)
            );
            document.title = formResponse.DATA.partnerName;
            setFavicon(formResponse.DATA.partnerFaviconLogoPath);
            setLoading(false);
          } else {
            let part = partnerDetails();
            document.title = part.partnerName;
            setFavicon(part.partnerFaviconLogoPath);
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
          if (!toast.isActive(toastId.current)) {
            toastId.current = toast.error(error);
          }
        });
    } catch (error) {
      console.error("Error fetching IP address:", error);
    }
  };

  // login API
  const submitLogin = async (mobile, password) => {
    setLoading(true);
    const info = {
      HEADER: {
        mobile: mobile,
        UDID: sessionStorage.getItem("ipAddress"),
        REQUEST_ID: generateRandomNumber(),
      },
      DATA: {
        password: password,
        // ...(isStoreUser && { storeUserMobile: storeUserMobile }),
      },
    };

    await HTTPS(loginUrlAppUrl, info)
      .then((formResponse) => {
        console.log("formResponse", formResponse);
        if (formResponse.RESP_CODE === 300) {
          authCtx.login(formResponse);
          sessionStorage.setItem("sellerCode", formResponse.DATA.sellerCode);
          sessionStorage.setItem("mobile", mobile);
          sessionStorage.setItem("storeName", formResponse.DATA.storeName);
          sessionStorage.setItem("partnerLogo", formResponse.DATA.partnerLogo);
          sessionStorage.setItem(
            "partnerLogo2",
            formResponse.DATA.partnerLogo2
          );
          const loginRespArr = [...formResponse.DATA.loginUserPermission];
          sessionStorage.setItem("loginUserPermission", loginRespArr);
          // console.log("loginUserPermission", loginRespArr);
          const loginPermArr = [];
          if (loginRespArr.includes("VIEW_PROFILE")) {
            loginPermArr.push("Profile");
          }
          if (loginRespArr.includes("VIEW_PRODUCTS")) {
            loginPermArr.push("My Products");
          }
          if (loginRespArr.includes("MANAGE_PRODUCTS")) {
            loginPermArr.push("My Products");
            loginPermArr.push("Add New");
            loginPermArr.push("Variant");
          }
          if (loginRespArr.includes("VIEW_ORDERS")) {
            loginPermArr.push("My Orders");
          }
          if (loginRespArr.includes("MANAGE_ORDERS")) {
            loginPermArr.push("My Products");
            loginPermArr.push("Add New");
            loginPermArr.push("Variant");
          }
          if (loginRespArr.includes("VIEW_RETURN_ORDERS")) {
            loginPermArr.push("Returns");
          }
          if (loginRespArr.includes("MANAGE_RETURN_ORDERS")) {
            loginPermArr.push("Returns");
          }
          if (loginRespArr.includes("VIEW_IGM")) {
            loginPermArr.push("Issues");
          }
          if (loginRespArr.includes("MANAGE_IGM")) {
            loginPermArr.push("Issues");
          }
          if (loginRespArr.includes("VIEW_CUSTOMER")) {
            loginPermArr.push("My Customers");
          }
          if (loginRespArr.includes("VIEW_BUYERS")) {
            loginPermArr.push("Buyer Activation");
          }
          if (loginRespArr.includes("MANAGE_BUYERS")) {
            loginPermArr.push("Buyer Activation");
          }
          if (loginRespArr.includes("VIEW_LSP")) {
            loginPermArr.push("LSP Activation");
          }
          if (loginRespArr.includes("MANAGE_LSP")) {
            loginPermArr.push("LSP Activation");
          }
          if (loginRespArr.includes("VIEW_SHIPMENT")) {
            loginPermArr.push("Shipments");
          }
          if (loginRespArr.includes("MANAGE_SHIPMENT")) {
            loginPermArr.push("Shipments");
          }
          if (loginRespArr.includes("MANAGE_BULK_INVOICE")) {
            loginPermArr.push("Bulk Invoice");
          }
          if (loginRespArr.includes("VIEW_PAYMENT")) {
            loginPermArr.push("Payments & Settlement");
          }
          if (loginRespArr.includes("VIEW_STORE_QR")) {
            loginPermArr.push("Store QR");
          }
          if (loginRespArr.includes("VIEW_OFFER")) {
            loginPermArr.push("Offers");
          }
          if (loginRespArr.includes("MANAGE_STORE")) {
            loginPermArr.push("Manage Store");
          }
          if (loginRespArr.includes("MANAGE_USER")) {
            loginPermArr.push("Manage User");
          }
          if (loginRespArr.includes("MANAGE_DOWNLOAD")) {
            loginPermArr.push("Manage Download");
          }
          sessionStorage.setItem("loginUserPermissionFields", loginPermArr);
          dispatch(setPreviousPath("/seller/dashboard"));
          navigate("/seller/kyc");
        } else {
          setLoading(false);
          if (!toast.isActive(toastId.current)) {
            toastId.current = toast.error(formResponse.RESP_MSG);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const getQueryParams = (url) => {
    const params = new URLSearchParams(new URL(url).search);
    return {
      crlLoginData: params ? params.get("crlLoginData") : undefined,
    };
  };

  const currentUrl = window.location.href;
  const { crlLoginData } = getQueryParams(currentUrl);

  if (crlLoginData && loginRequest) {
    const decodedString = atob(crlLoginData);
    const decodedCrlLoginData = JSON.parse(decodedString.trim());
    const { mobile, password } = decodedCrlLoginData;
    // console.log("decodedCrlLoginData", decodedCrlLoginData);
    setLoginRequest(false);
    mobile && password && submitLogin(mobile, password);
  }

  useEffect(() => {
    getUrlDetails();
  }, []);

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <Suspense fallback={<Spinner />}>
          <Routes>
            <Route
              path=""
              element={
                <Navigate
                  replace
                  to={isLoggedIn ? currentPath || "seller/dashboard" : "baas"}
                />
              }
            />
            {isLoggedIn && (
              <Route path="" element={<Home />}>
                <Route path="/seller/kyc" element={<StepLayout />} />
                <Route path="/seller/store-info" element={<StepLayout />} />
              </Route>
            )}
            {isLoggedIn && (
              <Route path="" element={<Home />}>
                <Route element={<PrivateRoute />}>
                  <Route path="/home" element={<HomePage />} />
                  <Route
                    path="/payIn/summary"
                    element={<Summary value={"payIn"} />}
                  />
                  <Route
                    path="/payOut/summary"
                    element={<Summary value={"payOut"} />}
                  />
                  <Route path="/payIn/transaction" element={<Transaction />} />
                  <Route path="/payOut/beneficiary" element={<Beneficiary />} />
                  <Route path="/payOut/wallet" element={<Wallet />} />
                  <Route
                    path="/payOut/transaction"
                    element={<OutTransaction />}
                  />
                  <Route path="/status/transfer" element={<TransferStatus />} />
                  <Route
                    path="/status/transfer/:transferId"
                    element={<DetailBulk />}
                  />
                  <Route
                    path="/status/details/:transferId"
                    element={<BulkUploadDetails />}
                  />
                  <Route path="/status/beneficiary" element={<BeneStatus />} />
                  <Route path="/change-password" element={<ChangePassword />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/vendor/ledger" element={<VendorWallet />} />
                  <Route path="/order/:orderId" element={<OrderHistory />} />
                  {/* Dashboard */}
                  <Route path="/seller/dashboard" element={<Dashboard />} />
                  {/* kyc */}
                  {/* <Route path="/seller/kyc" element={<StepLayout />} />
                  <Route path="/seller/store-info" element={<StepLayout />} /> */}
                  {/* Product */}
                  <Route
                    path="/seller/add-product"
                    element={<AddProduct key={"add-product"} />}
                  />
                  <Route
                    path="/seller/edit-product/:productId"
                    element={<AddProduct key={"edit-product"} />}
                  />
                  <Route
                    path="/seller/copy-product/:productId"
                    element={<AddProduct key={"copy-product"} />}
                  />
                  <Route
                    path="/seller/product-list"
                    element={<ProductList />}
                  />
                  <Route
                    path="/seller/product-list/:productId"
                    element={<ProductDetails />}
                  />
                  {/* NullVariantProductList */}
                  <Route
                    path="/seller/product-variant"
                    element={<NullVariantProductList />}
                  />
                  {/* MyVariant */}

                  <Route path="/seller/variant-list" element={<MyVariant />} />

                  {/* MyVariant */}

                  <Route
                    path="/seller/my-variant"
                    element={<MyVariantProduct />}
                  />
                  <Route
                    path="/seller/variant-list/:id"
                    element={<VariantProductList />}
                  />

                  <Route path="/seller/bulk-edit" element={<BulkEdit />} />

                  {/* Channels */}
                  <Route path="/seller/channels" element={<Channels />} />
                  <Route
                    path="/seller/channels/add"
                    element={<ChannelProductAdd />}
                  />

                  {/*MultiStores*/}
                  <Route
                    path="/seller/multi-stores"
                    element={<MultiStores />}
                  />
                  {/*MultiUsers*/}
                  <Route path="/seller/multiUsers" element={<MultiUsers />} />
                  <Route
                    path="/seller/addMultiUsers/:mobile"
                    element={<AddMultiUsers />}
                  />
                  {/* Orders */}
                  <Route path="/seller/orders" element={<OrderList />} />
                  <Route
                    path="/seller/orders/:ondcOrderId"
                    element={<OrderDetails />}
                  />
                  <Route
                    path="/seller/orders/:ondcOrderId/cancel"
                    element={<OrderCancel />}
                  />
                  <Route path="/seller/shipments" element={<ShipmentsList />} />
                  <Route
                    path="/seller/bulk-invoice"
                    element={<BulkInvoice />}
                  />
                  {/* Offers */}
                  <Route path="/seller/offers" element={<OfferList />} />
                  <Route
                    path="/seller/offers/:offerMstId"
                    element={<OfferDetails />}
                  />
                  <Route path="/seller/addoffers" element={<AddOffer />} />
                  <Route path="/seller/itemBased" element={<ItemBased />} />
                  <Route path="/seller/freebie" element={<Freebie />} />

                  {/* Store Qr */}
                  <Route path="/seller/storeQr" element={<StoreQrList />} />

                  {/* Return Order */}
                  <Route path="/seller/returns" element={<ReturnOrderList />} />
                  <Route
                    path="/seller/returns/:ondcReturnId"
                    element={<ReturnOrderDetails />}
                  />
                  {/* Issues */}
                  <Route path="/seller/issues" element={<IssueList />} />
                  <Route
                    path="/seller/issues/:ondcIssueId"
                    element={<IssueDetails />}
                  />
                  {/* Profile */}
                  <Route path="/seller/profile" element={<SellerProfile />} />
                  {/* Faq */}
                  <Route path="/seller/FreqAskQues" element={<FreqAskQues />} />
                  {/* Help */}
                  <Route path="/seller/help" element={<Help />} />
                  {/* Contact US */}
                  <Route path="/seller/contact" element={<Contact />} />
                  {/* Customer */}
                  <Route path="/seller/customers" element={<CustomerList />} />
                  {/* Buyer */}
                  <Route path="/seller/buyers" element={<BuyerList />} />
                  {/* LSP */}
                  <Route
                    path="/seller/logistic-partners"
                    element={<LogisticPartnerList />}
                  />
                  {/* Upgrade Plan */}
                  <Route path="/seller/upgrade-plan" element={<UpgradePlan />} />
                  <Route path="/seller/upgrade-plan/plans" element={<PlanList />} />
                  <Route path="/seller/payments" element={<Payments />} />
                  <Route path="/seller/ledger" element={<Ledger />} />
                  {/* Adjustments */}
                  <Route path="seller/adjustments" element={<Adjustments />} />
                  {/* Downloads */}
                  <Route path="/seller/downloads" element={<Downloads />} />
                  {/* TermsAndConditions */}
                  <Route
                    path="/seller/TermsAndConditions"
                    element={<TermsAndConditions />}
                  />
                  {/* Fees */}
                  <Route path="/seller/Fees" element={<Fees />} />
                  {/* Quotation */}
                  
                  <Route
                    path="/seller/add-quotation"
                    element={<AddQuotation />}
                  />
                  <Route
                    path="/seller/my-quotation"
                    element={<Categories />}
                  />
                  <Route
                    path="/seller/my-quotation/:categoryId"
                    element={<QuotationCategoryDetail />}
                  />
                  <Route
                    path="/seller/my-quotation/custom/new"
                    element={<CustomCategoryBuilder />}
                  />
                  <Route
                    path="/seller/my-quotation/custom/:customCategoryId/edit"
                    element={<CustomCategoryBuilder />}
                  />
                  <Route
                    path="/seller/my-quotation/:categoryId/:subcategoryId/products/add"
                    element={<QuotationProductForm />}
                  />
                  <Route
                    path="/seller/my-quotation/:categoryId/:subcategoryId/products/:productId/edit"
                    element={<QuotationProductForm />}
                  />
                 
                  <Route
                    path="/seller/manage-profile"
                    element={<ManageProfile />}
                  />
                  <Route
                    path="/seller/quotation-orders"
                    element={<QuotationOrders />}
                  />
                  <Route
                    path="/seller/quotation-orders/:orderId"
                    element={<QuotationOrderDetail />}
                  />
                  <Route
                    path="/seller/quotation-customers"
                    element={<QuotationCustomers />}
                  />
                  <Route
                    path="/seller/quotation-customers/:customerId"
                    element={<QuotationCustomerDetail />}
                  />
                </Route>
              </Route>
            )}
           
              {/* <Route 
               path="/seller/my-website"
               element={<MyWebsite />}
                /> */}

                <Route
                  path="/seller/my-website"
                  element={<ExternalRedirect />}
                 
                />
            
            {isLoggedIn && (
              <Route
                path="/seller/my-website/account"
                element={<MyWebsiteAccount />}
              />
            )}
            {isLoggedIn && (
              <Route
                path="/seller/my-website/category/:categoryId"
                element={<MyWebsiteCategoryProducts />}
              />
            )}
            {isLoggedIn && (
              <Route
                path="/seller/my-website/category/:categoryId/subcategory/:subcategoryId"
                element={<MyWebsiteSubcategoryProducts />}
              />
            )}
            {isLoggedIn && (
              <Route
                path="/seller/my-website/product/:productId"
                element={<MyWebsiteProductDetails />}
              />
            )}
            {isLoggedIn && (
              <Route path="/seller/my-website/cart" element={<MyWebsiteCart />} />
            )}
            {isLoggedIn && (
              <Route
                path="/seller/my-website/checkout"
                element={<MyWebsiteCheckout />}
              />
            )}
            {isLoggedIn && (
              <Route
                path="/seller/my-website/orders"
                element={<MyWebsiteOrderHistory />}
              />
            )}
            {isLoggedIn && (
              <Route path="/seller/my-website/pro" element={<MyWebsitePro />} />
            )}
            {!isLoggedIn && <Route element={<PrivateRoute />}></Route>}
            {!isLoggedIn && (
              <Route
                path="baas"
                element={<Baas setLocationPath={setLocationPath} />}
              >
                <Route path="/baas" element={<Navigate replace to="login" />} />
                <Route
                  path="login"
                  element={
                    <Login
                      locationPath={locationPath}
                      setLocationPath={setLocationPath}
                    />
                  }
                />
                <Route
                  path="registration"
                  element={
                    <Registration
                      locationPath={locationPath}
                      setLocationPath={setLocationPath}
                    />
                  }
                />
                <Route path="forget" element={<ForgetPassword />} />
                <Route path="otp" element={<Otp />} />
                <Route path="reset" element={<ResetPass />} />
                <Route path="ONDC" element={<LandingPage />} />
                <Route
                  path="ONDC"
                  element={
                    <Authentication
                      locationPath={locationPath}
                      setLocationPath={setLocationPath}
                    />
                  }
                >
                  <Route
                    path="registration"
                    element={
                      <OndcRegistration setLocationPath={setLocationPath} />
                    }
                  />
                  <Route
                    path="login"
                    element={<OndcLogin setLocationPath={setLocationPath} />}
                  />
                </Route>
              </Route>
            )}
            <Route path="*" element={<Navigate replace to={"/"} />} />
          </Routes>
          <ToastContainer className="custom-toast-container" />
        </Suspense>
      )}
    </>
  );
}
export default App;
